import { render, staticRenderFns } from "./WebhookConfig.vue?vue&type=template&id=283ac292&scoped=true"
import script from "./WebhookConfig.vue?vue&type=script&lang=js"
export * from "./WebhookConfig.vue?vue&type=script&lang=js"
import style0 from "./WebhookConfig.vue?vue&type=style&index=0&id=283ac292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283ac292",
  null
  
)

export default component.exports